import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {ModalSheet} from '../../../../components/common/ModalSheet/ModalSheet';
import {ContentText, StyledLink} from './styled';
import { useReservation } from 'context/reservation';
import { useFetchPrivacyPolicySettings } from 'hooks';

type TaxesInformationModalProps = {
  isOpen: boolean;
  close: () => void;
};
const TaxesInformationModal = memo(({isOpen, close}: TaxesInformationModalProps) => {
  const {t} = useTranslation();
  const { housingId } = useReservation();
  const { hasCustomPrivacyPolicy, documentDownload, isLoading } = useFetchPrivacyPolicySettings({housingId});
  return (
    <ModalSheet
      isOpenModalSheet={isOpen}
      handleCloseModal={close}
      title={t('tourist_taxes')}
      className="tax-info-modal"
      withCloseButton
    >
      <ContentText className="tax-info-modal__content">
        <p>{t('please_be_advised_that_in_this_territory')}</p>
        <p>{t('thank_you_for_your_understanding')}</p>

        {hasCustomPrivacyPolicy ? (
          <StyledLink
            download
            label={t('view_privacy_policy')}
            href={documentDownload}
            disabled={isLoading || !documentDownload}
          />
        ) : (
          <StyledLink
            label={t('view_privacy_policy')}
            href={t('guest_privacy_policy_link')}
          />)}
      </ContentText>
    </ModalSheet>
  );
});

export {TaxesInformationModal};
